export default __webpack_public_path__ + "static/media/cabinet1-before.f945ea61.jpg";